import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { matches, requestMatchesLevels1 } from 'src/interface/shared.interface';

@Component({
  selector: 'app-add-request',
  templateUrl: './add-request.component.html',
  styleUrls: ['./add-request.component.scss'],
})
export class AddRequestComponent {
  @Input() selectedRequest: matches | requestMatchesLevels1 | undefined;
  @Output() selectRequest = new EventEmitter<requestMatchesLevels1>();
  @Output() manualRequest = new EventEmitter<string>();
  selectedSearchType = 0;
  constructor(private activeRoute: ActivatedRoute) {
    this.activeRoute.params.subscribe(async (params) => {
      if (params['id']) {
        if (params['id'].includes('manual')) {
          this.selectedSearchType = 1;
        }
      }
    });
  }
}
